export const PROJECT_PLACEHOLDER_IMAGE = '/assets/Placeholders/project_placeholder.png';

export const isProjectPlaceholderImage = (url: string) => {
  // Is the given URL our project preview URL?
  // Useful to tell if the image should be zoomable etc.
  return url.endsWith(PROJECT_PLACEHOLDER_IMAGE);
};
